export const IconLikeFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M2 12a2 2 0 0 1 2-2h1a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a2 2 0 0 1-2-2zM22.311 12.525A2 2 0 0 0 20.383 10l-5.243-.002a.5.5 0 0 1-.485-.621l.716-2.862c.367-1.471-.336-3-1.692-3.678a1.294 1.294 0 0 0-1.866 1.029l-.218 2.177a3 3 0 0 1-.726 1.676l-2.375 2.717A2 2 0 0 0 8 11.75V19a2 2 0 0 0 2 2h7.709a3 3 0 0 0 2.894-2.21z" />
    </svg>
  );
};
